import React, { memo } from 'react';
import classNames from 'classnames';
import { AWStageDto } from '@api/Api';
import { useCurrentStage } from '@hooks/useCurrentStage';
import {
  CalendarV2Icon,
  ContributorsLimitErrorNotificationIcon,
  PanelCalendarIcon
} from '@icons';

type DeadlineCellProps = {
  stages: AWStageDto[];
  currentStageId?: string | null;
  isFinished: boolean;
  isPaused: boolean;
};

export default memo(function DeadlineCell({
  stages,
  currentStageId,
  isPaused,
  isFinished
}: DeadlineCellProps) {
  const { isPastDueDate, formattedDeadline } = useCurrentStage({
    stages,
    currentStageId,
    isFinished,
    isPaused
  });

  return (
    <div
      className={classNames('deadline-cell', {
        'b-has-deadline': !!formattedDeadline,
        'b-date--past': isPastDueDate
      })}
    >
      {!formattedDeadline && (
        <>
          <CalendarV2Icon />
          No deadline
        </>
      )}
      {!!formattedDeadline && (
        <>
          <PanelCalendarIcon />
          {formattedDeadline}
          {isPastDueDate && (
            <ContributorsLimitErrorNotificationIcon
              style={{ marginLeft: '4px', fontSize: 16 }}
            />
          )}
        </>
      )}
    </div>
  );
});
